module.exports = __webpack_public_path__ + "img/left_layout_icon.cfdaa846.svg";